module.exports = __webpack_public_path__ + "img/confetti_2e.408ac2b4.svg";